import React from 'react'

import { SubjectTracker } from 'buyer-intent-sdk/react'

import { useBuyerIntentTrackingEnabled } from './BuyerIntentTrackingContext'
import ErrorBoundary from './ErrorBoundary'
import { hasBuyerIntentIdentifiers, normalizeBuyerIntentProps } from './normalizeProps'

/** @type {import("react").FC<{
 *  productId?: string | number | null,
 *  productIds?: Array<string | number | null>,
 *  categoryId?: string | number | null,
 *  categoryIds?: Array<string | number | null>,
 * }>}
 */
const BuyerIntentSubject = ({ productId, productIds, categoryId, categoryIds }) => {
  const trackingEnabled = useBuyerIntentTrackingEnabled()
  const intentProps = normalizeBuyerIntentProps({
    productId,
    productIds,
    categoryId,
    categoryIds,
  })

  if (!trackingEnabled) {
    return null
  }

  if (!hasBuyerIntentIdentifiers(intentProps)) {
    return null
  }

  return (
    <ErrorBoundary fallback={null}>
      <SubjectTracker {...intentProps} />
    </ErrorBoundary>
  )
}

export default BuyerIntentSubject
